<template>
  <div
    ref="tooltipRoot"
    class="tooltip"
    :class="{
      '--right': isRightPosition,
      '--left': isLeftPosition
    }"
    @mouseenter="handleMouseEnter"
  >
    <div class="tooltip__item image-item">
      <nuxt-img
        :src="String(colorItem.imageId)"
        :width="40"
        :height="40"
        fit="cover"
        loading="lazy"
        :alt="`color-${colorItem.imageId}`"
      />
    </div>
    <div ref="refHover" class="tooltip__hover">
      <span v-html="colorItem.value"/>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  colorItem: {
    type: Object,
    default: () => {
      return {}
    }
  }
});

const tooltipRoot: any = ref(null);
const refHover: any = ref(null);
const isRightPosition: Ref<boolean> = ref(false);
const isLeftPosition: Ref<boolean> = ref(false);

const TOOLTIP_MAX_WIDTH = 140; // max-width из глобальных стилей (при изменении нужно подтянуть)
const TOOLTIP_OFFSET = 10; // отступ для безопасности

const handleMouseEnter = () => {
  if (isRightPosition.value || isLeftPosition.value) {
    return;
  }

  const elementTooltip = tooltipRoot.value;
  if (!elementTooltip) {
    return;
  }

  const positions = elementTooltip.getBoundingClientRect();
  const elementWidth = positions.width;

  // По умолчанию тултип позиционируется с right: 50%
  const tooltipRightEdge = positions.left + elementWidth * 0.5;

  // Левый край тултипа (предполагая максимальную ширину)
  const tooltipLeftEdge = tooltipRightEdge - TOOLTIP_MAX_WIDTH;

  // Проверяем левую границу экрана
  const wouldOverflowLeft = tooltipLeftEdge < TOOLTIP_OFFSET;

  // Проверяем правую границу экрана
  const wouldOverflowRight = tooltipRightEdge > (window.innerWidth - TOOLTIP_OFFSET);

  if (wouldOverflowLeft) {
    // Если тултип выходит за левую границу, позиционируем его слева
    isLeftPosition.value = true;
  } else if (wouldOverflowRight) {
    // Если тултип выходит за правую границу, позиционируем его справа
    isRightPosition.value = true;
  }
};

onMounted(() => {
  handleMouseEnter();
});
</script>

<style scoped lang="scss">
.tooltip {
  position: relative;

  .tooltip__hover {
    display: none;
    will-change: transform;
    width: max-content !important;
    transition: opacity 0.2s ease;
  }
  &.--right {
    .tooltip__hover {
      left: initial;
      right: 10px;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 15px;
      &:after {
        left: initial;
        right: 0;
        border-right: 15px solid #F4F3F1;
        border-left-color: transparent;
      }
    }
  }
  &.--left {
    .tooltip__hover {
      right: initial;
      left: 10px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 15px;
      &:after {
        right: initial;
        left: 0;
        border-left: 15px solid #F4F3F1;
        border-right-color: transparent;
      }
    }
  }
  &.is-visible .tooltip__hover {
    display: block; // Показываем при hover
    opacity: 1;
  }
}
</style>
